import { Popover, Typography } from '@mui/material'
import classNames from 'classnames'
import { useRef, useState } from 'react'
import Buttons from './Accessibility/Buttons'
import ColorSwitcher from './Accessibility/ColorSwitcher'
import FontSizeSwitcher from './Accessibility/FontSizeSwitcher'
import LetterSpacingSwitcher from './Accessibility/LetterSpacingSwitcher'
import AccessibilityIcon from './Icons/AccessibilityIcon'

const Accessibility = () => {
  const accessibilityContainerRef = useRef(null)
  const [anchorEl, setAnchorEl] = useState(null)
  const openPopover = Boolean(anchorEl)

  const handlePopover = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <div
        className={classNames('accessibility', { open: openPopover })}
        onClick={handlePopover}
        ref={accessibilityContainerRef}
      >
        <AccessibilityIcon />
        <span className="accessibility_title">Налаштування доступності</span>
      </div>

      <Popover
        open={openPopover}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        container={accessibilityContainerRef.current}
        className="accessibility_popover"
      >
        <Typography className="popover_title">Вебдоступність</Typography>
        <Typography className="popover_subtitle">
          Налаштування для людей з особливостями
        </Typography>

        <div className="accessibility_switchers">
          <FontSizeSwitcher />
          <LetterSpacingSwitcher />
        </div>

        <ColorSwitcher />
        <Buttons />
      </Popover>
    </>
  )
}

export default Accessibility
